let mergeTagCategories = [
  {
    id: "website",
    label: "Website",
    includedTriggers: [
      "wp-signup-admin",
      "wp-signup-user",
      "wp-lost-password-admin",
      "wp-lost-password-user",
      "wp-password-changed-user",
      "wp-change-user-email-user",
      "wp-changed-user-email-user",
      "wp-automatic-core-update",
      "wp-change-site-admin-email",
      "wp-changed-site-admin-email",
      "wp-comment-in-moderation-admin",
      "wp-comment-published-post-author",
      "wp-request-personal-data-user",
      "wp-confirmed-personal-data-request-admin",
      "wp-download-personal-data-user",
      "wp-erased-personal-data-user",
      "gravityforms",
    ],
  },

  {
    id: "recipientUser",
    label: "Recipient User",
    includedTriggers: [],
  },
  {
    id: "post",
    label: "Post",
    includedTriggers: [
      "wp-comment-in-moderation-admin",
      "wp-comment-published-post-author",
    ],
  },
  {
    id: "comment",
    label: "Comment",
    includedTriggers: [
      "wp-comment-in-moderation-admin",
      "wp-comment-published-post-author",
    ],
  },
  {
    id: "user",
    label: "User",
    includedTriggers: [
      "wp-signup-admin",
      "wp-signup-user",
      "wp-lost-password-admin",
      "wp-lost-password-user",
      "wp-comment-in-moderation-admin",
      "wp-comment-published-post-author",
      "wp-password-changed-user",
      "wp-change-site-admin-email",
    ],
  },
  {
    id: "userLostPassword",
    label: "User Lost Password",
    includedTriggers: ["wp-lost-password-user", "wp-lost-password-user"],
  },
  {
    id: "userRegistration",
    label: "User Registration",
    includedTriggers: ["wp-signup-user"],
  },
  {
    id: "userEmailChangedForAdmin",
    label: "User Email Change For Admin",
    includedTriggers: [""],
  },
  {
    id: "userEmailChangedForUser",
    label: "User Email Change For User",
    includedTriggers: ["wp-changed-user-email-user"],
  },
  {
    id: "emailChangedConfirmationForUser",
    label: "Email Changed Confirmation For User",
    includedTriggers: ["wp-change-user-email-user"],
  },
  // {
  //   id: "wpCoreAutomaticUpdateStatus",
  //   label: "Wp Core Automatic Update Status",
  //   includedTriggers: ["wp-automatic-core-update"],
  // },
  // {
  //   id: 'wpCoreAutomaticUpdateStatus',
  //   includedTriggers: ['wp-automatic-core-update'],
  // },
  {
    id: "wpChangeSiteAdminEmail",
    label: "Wp Change Admin Email",
    includedTriggers: ["wp-change-site-admin-email"],
  },
  {
    id: "wpChangedSiteAdminEmail",
    label: "Wp Changed Site Admin Email",
    includedTriggers: ["wp-changed-site-admin-email"],
  },
  {
    id: "privacyConfirmAction",
    label: "Privacy Confirm Action",
    includedTriggers: ["wp-request-personal-data-user"],
  },
  {
    id: "privacyUserConfirmedAction",
    label: "Privacy User Confirmed Action",
    includedTriggers: ["wp-confirmed-personal-data-request-admin"],
  },
  {
    id: "privacyDataExport",
    label: "Privacy Data Export",
    includedTriggers: ["wp-download-personal-data-user"],
  },
  {
    id: "erasedPersonalData",
    label: "Erased Personal Data",
    includedTriggers: ["wp-erased-personal-data-user"],
  },
];

let mergeTags = [
  {
    id: "[global_site_title]",
    label: "Site Title",
    category: "website",
  },
  {
    id: "[global_site_tagline]",
    label: "Site Tagline",
    category: "website",
  },
  {
    id: "[global_site_url]",
    label: "Site URL",
    category: "website",
  },
  {
    id: "[admin_email]",
    label: "Site Admin Email",
    category: "website",
  },
  {
    id: "[current_date]",
    label: "Current Date",
    category: "website",
  },
  {
    id: "[current_time]",
    label: "Current Time",
    category: "website",
  },

  {
    id: "[email_user_id]",
    label: "Recipient User ID",
    category: "recipientUser",
  },
  {
    id: "[email_user_login]",
    label: "Recipient User Login",
    category: "recipientUser",
  },
  {
    id: "[email_user_nicename]",
    label: "Recipient User Nicename",
    category: "recipientUser",
  },
  {
    id: "[email_user_email]",
    label: "Recipient User Email",
    category: "recipientUser",
  },
  {
    id: "[email_user_url]",
    label: "Recipient User URL",
    category: "recipient",
  },
  {
    id: "[email_user_registered]",
    label: "Recipient User Registered",
    category: "recipientUser",
  },
  {
    id: "[email_user_display_name]",
    label: "Recipient Display Name",
    category: "recipientUser",
  },
  {
    id: "[email_user_firstname]",
    label: "Recipient User Firstname",
    category: "recipientUser",
  },
  {
    id: "[email_user_lastname]",
    label: "Recipient User Lastname",
    category: "recipientUser",
  },
  {
    id: "[email_user_nickname]",
    label: "Recipient Nickname",
    category: "recipientUser",
  },
  {
    id: "[email_user_description]",
    label: "Recipient User Description",
    category: "recipientUser",
  },
  {
    id: "[email_user_wp_capabilities]",
    label: "Recipient Capabilities",
    category: "recipientUser",
  },
  {
    id: "[email_user_avatar]",
    label: "Recipient User Avatar",
    category: "recipientUser",
  },
  // {
  // 	id: '[email_user_custom_field field='X']', //(Custom Fields add-on only)//
  // 	label: 'Recipient User Profile Custom Field',
  // 	category: 'recipientUser'
  // },
  // {
  // 	id: '[user_subscription_page]', //(Subscriptions add-on only)//
  // 	label: 'Manage BNFW Notification Subscriptions in WP Admin Profile',
  // 	category: 'recipientUser'
  // },

  {
    id: "[permalink]",
    label: "Permalink",
    category: "post",
  },
  {
    id: "[ID]",
    label: "Post ID",
    category: "post",
  },
  {
    id: "[post_author]",
    label: "Original Post Author",
    category: "post",
  },
  {
    id: "[post_date]",
    label: "Post Date",
    category: "post",
  },
  {
    id: "[post_date_gmt]",
    label: "Post Date (GMT)",
    category: "post",
  },
  {
    id: "[post_content]",
    label: "Post Content",
    category: "post",
  },
  {
    id: "[post_title]",
    label: "Post Title",
    category: "post",
  },
  {
    id: "[post_category]",
    label: "Post Category",
    category: "post",
  },
  {
    id: "[post_category_description]",
    label: "First Category Description of Post",
    category: "post",
  },
  {
    id: "[post_category_slug]",
    label: "First Category Slug of Post",
    category: "post",
  },
  {
    id: "[post_term taxonomy='TAXONOMY_NAME']",
    label: "Post Term(s)",
    category: "post",
  },
  {
    id: "[post_tag]",
    label: "Post Tag(s)",
    category: "post",
  },
  {
    id: "[post_excerpt]",
    label: "Post Excerpt",
    category: "post",
  },
  {
    id: "[post_status]",
    label: "Post Status",
    category: "post",
  },
  {
    id: "[comment_status]",
    label: "Comment Status",
    category: "post",
  },
  {
    id: "[ping_status]",
    label: "Ping Status",
    category: "post",
  },
  {
    id: "[post_password]",
    label: "Post Password",
    category: "post",
  },
  {
    id: "[post_name]",
    label: "Post Name",
    category: "post",
  },
  {
    id: "[to_ping]",
    label: "To Ping",
    category: "post",
  },
  {
    id: "[pinged]",
    label: "Pinged",
    category: "post",
  },
  {
    id: "[post_modified]",
    label: "Post Modified",
    category: "post",
  },
  {
    id: "[post_modified_gmt]",
    label: "Post Modified (GMT)",
    category: "post",
  },
  {
    id: "[post_content_filtered]",
    label: "Post Content Filtered",
    category: "post",
  },
  {
    id: "[Post Parent]",
    label: "Post Parent",
    category: "post",
  },
  {
    id: "[guid]",
    label: "GUID",
    category: "post",
  },
  {
    id: "[menu_order]",
    label: "Menu Order",
    category: "post",
  },
  {
    id: "[post_type]",
    label: "Post Type",
    category: "post",
  },
  {
    id: "[post_mime_type]",
    label: "Post MIME Type",
    category: "post",
  },
  {
    id: "[comment_count]",
    label: "Comment Count",
    category: "post",
  },
  {
    id: "[edit_post]",
    label: "Edit Post Link",
    category: "post",
  },
  {
    id: "[post_slug]",
    label: "Post Slug",
    category: "post",
  },
  {
    id: "[post_parent_permalink]",
    label: "Permalink to Post Parent",
    category: "post",
  },
  {
    id: "[author_link]",
    label: "Link to Post Author Archive",
    category: "post",
  },
  {
    id: "[post_type_archive]",
    label: "Link to Post Type Archive",
    category: "post",
  },
  {
    id: "[featured_image]",
    label: "Featured Image",
    category: "post",
  },
  {
    id: "[first_image]",
    label: "First Image in Post",
    category: "post",
  },
  {
    id: "[custom_field field='X' type='Y' format='Z']", //(Custom Fields add-on only)//
    label: "Custom Field",
    category: "post",
  },

  {
    id: "[user_id]",
    label: "User ID",
    category: "user",
  },
  {
    id: "[user_login]",
    label: "User Login",
    category: "user",
  },
  {
    id: "[user_role]",
    label: "User Role",
    category: "user",
  },
  {
    id: "[user_nicename]",
    label: "User Nicename",
    category: "user",
  },
  {
    id: "[user_email]",
    label: "User Email",
    category: "user",
  },
  {
    id: "[user_url]",
    label: "User URL",
    category: "user",
  },
  {
    id: "[user_registered]",
    label: "User Registered",
    category: "user",
  },
  {
    id: "[display_name]",
    label: "Display Name",
    category: "user",
  },
  {
    id: "[user_firstname]",
    label: "User Firstname",
    category: "user",
  },
  {
    id: "[user_lastname]",
    label: "User Lastname",
    category: "user",
  },
  {
    id: "[nickname]",
    label: "Nickname",
    category: "user",
  },
  {
    id: "[user_description]",
    label: "User Description",
    category: "user",
  },
  {
    id: "[wp_capabilities]",
    label: "Capabilities",
    category: "user",
  },
  {
    id: "[user_avatar]",
    label: "User Avatar",
    category: "user",
  },
  // {
  // 	id: '[user_custom_field field='X']', // (Custom Fields add-on only)//
  // 	label: 'User Profile Custom Field',
  // 	category: 'user'
  // },

  {
    id: "[password_reset_link]",
    label: "Password Reset Link",
    category: "userLostPassword",
  },

  {
    id: "[login_url]",
    label: "Login URL",
    category: "userRegistration",
  },
  {
    id: "[password_url]", //(WordPress > 4.3)//
    label: "Set-up Password URL",
    category: "userRegistration",
  },

  {
    id: "[user_old_email]",
    label: "User Previouss Email Addressss",
    category: "userEmailChangedForAdmin",
  },
  {
    id: "[user_new_email]",
    label: "User Neww Email Address",
    category: "userEmailChangedForAdmin",
  },

  {
    id: "[user_old_email]",
    label: "User Previous Email Address",
    category: "userEmailChangedForUser",
  },
  {
    id: "[user_new_email]",
    label: "User New Email Address",
    category: "userEmailChangedForUser",
  },
  {
    id: "[username]",
    label: "Username",
    category: "userEmailChangedForUser",
  },

  {
    id: "[email_change_confirmation_link]",
    label: "Email Change Confirmation URL",
    category: "emailChangedConfirmationForUser",
  },
  {
    id: "[new_email]",
    label: "New Email Address",
    category: "emailChangedConfirmationForUser",
  },
  {
    id: "[username]",
    label: "Username",
    category: "emailChangedConfirmationForUser",
  },

  {
    id: "[core_update_status]",
    label: "WordPress Core Update Status",
    category: "wpCoreAutomaticUpdateStatus",
  },
  {
    id: "[change_email_link]",
    label: "Change Email Link",
    category: "wpChangeSiteAdminEmail",
  },
  {
    id: "[new_email]",
    label: "New Email",
    category: "wpChangeSiteAdminEmail",
  },
  {
    id: "[old_email]",
    label: "Old Email Address",
    category: "wpChangedSiteAdminEmail",
  },
  {
    id: "[new_email]",
    label: "New Email Address",
    category: "wpChangedSiteAdminEmail",
  },
  {
    id: "[comment_moderation_link]",
    label: "Comment Moderation Link",
    category: "comment",
  },
  {
    id: "[comment_moderation_approve]",
    label: "Comment Moderation - Approve",
    category: "comment",
  },
  {
    id: "[comment_moderation_spam]",
    label: "Comment Moderation - SPAM",
    category: "comment",
  },
  {
    id: "[comment_moderation_delete]",
    label: "Comment Moderation - Delete",
    category: "comment",
  },
  {
    id: "[comment_ID]",
    label: "Comment ID",
    category: "comment",
  },
  {
    id: "[comment_post_ID]",
    label: "Comment Post ID",
    category: "comment",
  },
  {
    id: "[comment_author]",
    label: "Comment Author",
    category: "comment",
  },
  {
    id: "[comment_author_email]",
    label: "Comment Author Email",
    category: "comment",
  },
  {
    id: "[comment_author_url]",
    label: "Comment Author URL",
    category: "comment",
  },
  {
    id: "[comment_author_IP]",
    label: "Comment Author IP",
    category: "comment",
  },
  {
    id: "[comment_author_domain]",
    label: "Comment Author Domain",
    category: "comment",
  },
  {
    id: "[comment_date]",
    label: "Comment Date",
    category: "comment",
  },
  {
    id: "[comment_date_gmt]",
    label: "Comment Date (GMT)",
    category: "comment",
  },
  {
    id: "[comment_content]",
    label: "Comment Content",
    category: "comment",
  },
  {
    id: "[comment_karma]",
    label: "Comment Karma",
    category: "comment",
  },
  {
    id: "[comment_approved]",
    label: "Comment Status",
    category: "comment",
  },
  {
    id: "[comment_agent]",
    label: "Comment Agent",
    category: "comment",
  },
  {
    id: "[comment_type]",
    label: "Comment Type",
    category: "comment",
  },
  {
    id: "[comments_count_in_moderation]",
    label: "Comments Count in Moderation",
    category: "comment",
  },
  {
    id: "[comment_moderation_panel_url]",
    label: "Comment Moderation Panel",
    category: "comment",
  },
  {
    id: "[comment_parent]",
    label: "Comment Parent",
    category: "comment",
  },
  {
    id: "[comment_parent_content]",
    label: "Parent Comment Content",
    category: "comment",
  },
  {
    id: "[data_request_type]",
    label: "Request Type",
    category: "privacyConfirmAction",
  },
  {
    id: "[request_confirmation_link]",
    label: "Confirm Request Link",
    category: "privacyConfirmAction",
  },
  {
    id: "[email_user_email]",
    label: "User's Email",
    category: "privacyUserConfirmedAction",
  },
  {
    id: "[data_request_type]",
    label: "Request Type",
    category: "privacyUserConfirmedAction",
  },
  {
    id: "[data_privacy_requests_url]",
    label: "Privacy Request Management Page",
    category: "privacyUserConfirmedAction",
  },
  {
    id: "[data_privacy_download_expiry]",
    label: "Data Download Link Expiry Date",
    category: "privacyDataExport",
  },
  {
    id: "[data_privacy_download_url]",
    label: "Data Download Link",
    category: "privacyDataExport",
  },
  {
    id: "[sitename]",
    label: "Sitename",
    category: "erasedPersonalData",
  },
];

if (!!window.wp) {
  mergeTagCategories = window.wp.hooks.applyFilters(
    "wpmNotificationGravityFormsMergeTagCategory",
    mergeTagCategories
  );

  mergeTags = window.wp.hooks.applyFilters(
    "wpmNotificationGravityFormsMergeTags",
    mergeTags
  );
}

export { mergeTagCategories, mergeTags };
